class VanillaHoverAnimation {
  constructor(selector = ".js-hover-animation", options = {}) {
    this.selector = selector;
    this.activeClass = options.activeClass || "is-link-active";

    this.init();
  }

  init() {
    const elements = document.querySelectorAll(this.selector);

    if (!elements.length) return;

    elements.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        this.play(element);
      });

      element.addEventListener("animationend", () => {
        element.classList.remove(this.activeClass);
      });
    });
  }

  play(element) {
    if (element.classList.contains(this.activeClass)) return;

    element.classList.add(this.activeClass);
  }
}

export default VanillaHoverAnimation;
